/* @flow */

import { isDate } from "platopulse/lib/schema_metadata";

import PivotByAction from "./PivotByAction";
import { t } from "c-3po";

export default PivotByAction(t`Time`, "clock", field => isDate(field));



// WEBPACK FOOTER //
// ./qb/components/actions/PivotByTimeAction.jsx